module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_4.a40ad605.png";